'use client'

import { Switch } from '@headlessui/react'
import cx from 'classnames'
import s from './checkbox.module.css'
import React from 'react'
import { LabelInfo } from '@/components/v1/ui/inputTextArea/inputTextArea.style'

type Props = {
  label: React.ReactNode
  checked: boolean
  onChange: (value: boolean) => void
  className?: string
  children?: React.ReactNode
  labelInfo?: string
}

export const Checkbox = ({
  label,
  checked = false,
  onChange,
  className,
  children,
  labelInfo,
}: Props) => {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      className={cx(s.switch, className)}
    >
      <span className={s.tick} />
      <span className={s.label}>{children || label}</span>
      {labelInfo && <LabelInfo>{labelInfo}</LabelInfo>}
    </Switch>
  )
}
